import React, { SVGProps, forwardRef, Ref } from 'react';

type Props = {
  title?: React.ReactNode;
  titleId?: string;
} & SVGProps<SVGSVGElement>;

function SVGSyntheZ({ title, titleId, ...props }: Props, svgRef?: Ref<SVGSVGElement>): JSX.Element {
  return (
    <svg
      viewBox="0 0 692 645"
      width="800"
      height="800"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#FF0001"
        opacity="1.000000"
        stroke="none"
        d="
M693.000000,103.000000
	C693.000000,110.020950 693.000000,117.041893 692.693481,124.819618
	C692.230591,138.715988 691.937744,151.855606 691.939209,164.995193
	C691.951599,279.425537 692.012817,393.855865 692.104675,508.286163
	C692.105896,509.857666 692.688660,511.428741 693.000000,513.000000
	C693.000000,524.687561 693.000000,536.375122 692.615723,548.317993
	C691.489319,551.331604 690.627380,554.063965 690.024109,556.852295
	C685.400513,578.222046 675.692505,596.857971 660.713806,612.861450
	C647.088440,627.419006 630.580261,637.256104 612.015198,644.001404
	C611.207947,644.294739 610.665710,645.317200 610.000000,646.000000
	C434.979095,646.000000 259.958221,646.000000 84.762253,645.679688
	C83.934616,644.912231 83.341217,644.300049 82.620918,644.041687
	C61.892307,636.607361 43.906742,625.349365 29.562382,608.229187
	C14.401156,590.134094 5.529358,569.627380 2.919117,546.261902
	C2.828043,545.446655 1.663970,544.751282 1.000003,544.000000
	C1.000000,398.645782 1.000000,253.291550 1.394466,107.670029
	C2.189365,106.562233 2.793999,105.759224 2.956399,104.875000
	C3.868368,99.909622 4.322172,94.834190 5.576090,89.961998
	C11.166583,68.239708 22.123236,49.691135 38.331245,34.063171
	C56.209244,16.824991 77.248703,6.441650 101.779091,2.922543
	C102.594551,2.805558 103.263016,1.663980 104.000000,1.000001
	C107.692909,1.000000 111.385818,1.000000 115.820068,1.315464
	C117.874397,1.763567 119.187386,2.012255 120.500389,2.012381
	C270.774109,2.026698 421.047852,2.025608 571.321594,1.977154
	C572.881165,1.976652 574.440552,1.339787 576.000000,0.999999
	C580.024536,1.000000 584.049072,1.000000 588.335815,1.394570
	C589.437805,2.189495 590.253845,2.875117 591.120911,2.947190
	C603.118896,3.944534 614.396667,7.571691 625.167603,12.682609
	C639.630981,19.545683 652.261292,28.821779 662.759766,41.133461
	C677.600159,58.536915 687.556763,78.075714 691.076477,100.782288
	C691.203430,101.601219 692.336060,102.264290 693.000000,103.000000
M168.235062,340.128876
	C187.792862,310.844513 207.360733,281.566864 226.905945,252.274124
	C253.002014,213.163574 279.101959,174.055542 305.097290,134.878159
	C306.282410,133.092102 306.990784,130.641907 307.016113,128.490372
	C307.184937,114.162537 307.116211,99.831772 307.095459,85.502007
	C307.093414,84.084976 306.894836,82.668236 306.797791,81.387405
	C228.220154,81.387405 150.147461,81.387405 72.002266,81.387405
	C72.002266,99.958664 72.002266,118.222649 72.002266,136.874207
	C122.670357,136.874207 173.063309,136.874207 224.131424,136.874207
	C223.220093,138.389938 222.694839,139.352737 222.087570,140.260666
	C201.501587,171.038498 180.893219,201.801376 160.318741,232.586899
	C133.280334,273.044464 106.262932,313.516052 79.264748,354.000519
	C78.363426,355.352051 77.149010,356.899658 77.128807,358.370270
	C76.957993,370.801270 77.031326,383.235626 77.031326,395.734497
	C154.006104,395.734497 230.401764,395.734497 306.755676,395.734497
	C306.755676,377.582245 306.755676,359.722076 306.755676,341.446472
	C302.525604,341.446472 298.703003,341.441895 294.880432,341.447205
	C254.395111,341.503601 213.909775,341.570465 173.424438,341.588867
	C171.669281,341.589661 169.913910,341.148804 168.235062,340.128876
M635.911011,231.500061
	C635.905457,190.012115 635.879639,148.524139 635.918579,107.036232
	C635.923767,101.513260 634.847229,96.465309 630.807983,92.429283
	C618.080139,79.711426 605.345642,67.000069 592.584961,54.315144
	C588.238647,49.994633 582.856079,48.047916 576.811157,48.044365
	C524.493164,48.013645 472.175201,48.018356 419.857208,48.025101
	C413.589294,48.025909 408.192352,50.175591 403.719360,54.640862
	C392.166718,66.173546 380.659851,77.754028 368.970245,89.146637
	C364.765533,93.244469 362.820221,97.826599 362.822937,103.748009
	C362.864594,195.386108 362.784698,287.024261 362.737122,378.662415
	C362.730957,390.531555 368.150879,396.013367 380.116180,396.016388
	C459.092743,396.036316 538.069275,396.033234 617.045837,396.003967
	C630.854187,395.998871 635.944641,390.795013 635.942261,376.957397
	C635.933838,328.804962 635.922668,280.652496 635.911011,231.500061
M440.359863,555.012329
	C440.525024,538.863464 440.876709,522.713806 440.803955,506.566040
	C440.728027,489.719635 427.469513,478.867584 411.108154,482.922699
	C404.709564,484.508575 398.961639,488.719421 392.860046,491.763336
	C392.860046,478.841156 392.860046,465.269196 392.860046,451.649475
	C386.749451,451.649475 381.022461,451.649475 375.359497,451.649475
	C375.359497,487.223236 375.359497,522.441772 375.359497,557.693665
	C381.411896,557.693665 387.134949,557.693665 393.185364,557.693665
	C393.185364,542.836365 393.905121,528.313721 392.906372,513.910217
	C392.337646,505.708740 396.139130,502.148712 402.304779,499.195007
	C403.198608,498.766785 404.113190,498.368164 405.048157,498.041595
	C415.602783,494.355194 422.931946,499.473969 422.980408,510.660889
	C423.041718,524.814392 422.998169,538.968262 422.999817,553.122009
	C423.000000,554.698730 422.999847,556.275452 422.999847,557.991943
	C428.267334,557.991943 432.764435,558.119812 437.244141,557.897949
	C438.302856,557.845520 439.303314,556.617065 440.359863,555.012329
M529.743286,472.481445
	C532.643433,472.781342 535.541565,473.315613 538.444031,473.340057
	C550.190125,473.439056 561.937561,473.381134 574.534546,473.381134
	C573.532715,474.923126 573.116577,475.572510 572.691772,476.216217
	C558.612000,497.553528 544.706604,519.009399 530.334839,540.148254
	C526.463074,545.843079 526.851990,551.491150 527.335083,557.680908
	C551.532837,557.680908 575.408203,557.680908 599.522827,557.680908
	C599.522827,552.608093 599.522827,547.865234 599.522827,542.419128
	C582.935669,542.419128 566.611938,542.419128 549.535889,542.419128
	C551.312500,539.656921 552.522034,537.723572 553.782898,535.824280
	C566.179504,517.151306 578.196289,498.207611 591.183777,479.954803
	C596.178406,472.935333 595.999084,465.965332 595.727173,458.283295
	C573.561951,458.283295 551.713013,458.283295 529.704102,458.283295
	C529.704102,462.969543 529.704102,467.281403 529.743286,472.481445
M111.482811,558.055969
	C119.403709,557.965149 127.597137,559.155945 135.193848,557.540588
	C157.017365,552.899841 161.390884,535.451538 157.914871,521.414551
	C155.557678,511.895691 148.189865,506.689453 139.699570,502.962189
	C132.729965,499.902557 125.608261,497.183441 118.686653,494.022827
	C114.854691,492.273071 111.489815,489.765198 110.909485,485.026886
	C110.022255,477.782745 114.068901,473.055603 121.930664,471.966492
	C132.772522,470.464600 142.899612,473.491180 153.788910,477.286987
	C153.788910,472.616272 153.964462,468.510559 153.675613,464.437775
	C153.595169,463.303314 152.360565,461.672424 151.283875,461.274414
	C137.411514,456.146332 123.408066,454.024628 109.090187,459.763245
	C99.095428,463.769135 94.031090,471.296936 92.922951,481.727966
	C91.769066,492.589691 95.906395,501.042114 105.371971,506.395508
	C110.666672,509.390045 116.494446,511.434204 122.046257,513.984497
	C126.397865,515.983337 130.921692,517.738586 134.956558,520.261719
	C139.711090,523.234802 140.771179,528.265503 139.922913,533.472168
	C139.153687,538.193665 135.866547,541.450317 131.303864,541.961853
	C124.814934,542.689331 118.109856,543.167603 111.684204,542.325195
	C104.774704,541.419373 98.081406,538.864319 91.274399,537.023621
	C91.340118,556.407043 87.256859,551.096008 105.758842,556.935364
	C107.331284,557.431702 108.994286,557.641113 111.482811,558.055969
M217.875320,528.417603
	C222.796951,513.715881 227.718597,499.014099 232.747070,483.993225
	C228.109024,483.993225 223.912689,484.347900 219.805725,483.893982
	C215.653366,483.435028 214.047012,485.041534 212.970108,488.882507
	C208.614426,504.417877 203.947586,519.866028 199.071091,536.449890
	C192.505814,518.354614 186.286163,501.211945 180.148346,484.294800
	C173.316650,484.294800 166.957184,484.294800 160.139557,484.294800
	C169.426819,507.107697 178.569885,529.441833 187.571106,551.832947
	C188.706604,554.657654 190.328186,558.123413 189.612350,560.706848
	C186.926926,570.398315 180.961929,575.437195 171.149277,574.153625
	C169.869919,573.986267 168.549805,574.130737 167.199234,574.130737
	C166.285995,578.432312 165.436249,582.434814 164.602753,586.360779
	C182.404297,592.740906 198.150131,584.849487 204.871475,566.299927
	C209.329453,553.996765 213.378296,541.545349 217.875320,528.417603
M472.073853,485.397919
	C459.992401,491.752258 453.794006,502.305603 452.395508,515.350037
	C450.780090,530.417786 453.321747,544.717041 467.417145,553.486389
	C482.303131,562.747559 498.229828,560.898132 514.011719,555.566345
	C514.846680,555.284363 515.732239,553.569214 515.689636,552.559326
	C515.544312,549.107788 514.994690,545.673157 514.688477,543.007996
	C506.481110,544.030212 498.509766,545.709778 490.510315,545.856445
	C478.888702,546.069641 470.599792,537.454224 471.404846,526.637817
	C478.827026,526.637817 486.297394,526.637878 493.767761,526.637878
	C501.409607,526.637878 509.051422,526.637817 517.101746,526.637817
	C517.599121,523.778625 518.371704,521.039185 518.509277,518.268188
	C519.351868,501.294647 513.239014,485.322479 493.223328,482.631744
	C486.632446,481.745728 479.597778,484.161194 472.073853,485.397919
M251.194092,483.991394
	C247.609604,483.991394 244.025101,483.991394 240.543793,483.991394
	C240.543793,509.084045 240.543793,533.438904 240.543793,557.822327
	C246.612411,557.822327 252.235168,557.822327 258.434326,557.822327
	C258.434326,542.794800 258.509796,528.013977 258.406738,513.234436
	C258.342255,503.982727 259.288391,502.333435 267.800049,498.746094
	C280.045776,493.584930 287.850800,498.700043 287.798706,511.880463
	C287.746094,525.196960 287.658051,538.513306 287.588928,551.829712
	C287.578796,553.785400 287.587524,555.741272 287.587524,557.800415
	C293.466309,557.800415 298.741150,557.800415 304.996796,557.800415
	C304.996796,540.149292 305.054657,522.709045 304.981262,505.269379
	C304.900787,486.145752 289.371155,480.892395 276.787354,482.419098
	C268.624420,483.409424 262.240753,487.965820 256.586212,494.250916
	C256.024170,491.499237 255.868561,489.312561 255.082382,487.382751
	C254.546844,486.068176 253.129242,485.112946 251.194092,483.991394
M342.593323,496.788269
	C348.899689,496.788269 355.206085,496.788269 361.807892,496.788269
	C361.807892,492.072357 361.807892,488.176849 361.807892,483.839050
	C355.259033,483.839050 348.846069,483.839050 341.848511,483.839050
	C341.848511,477.034332 341.848511,470.649078 341.848511,464.259277
	C335.971771,464.259277 330.699066,464.259277 325.120911,464.259277
	C324.603546,470.847046 324.102264,477.230133 323.560547,484.128113
	C319.880280,484.128113 316.485443,484.128113 313.123474,484.128113
	C313.123474,488.456726 313.123474,492.220276 313.123474,496.277710
	C316.800598,496.477478 320.212769,496.662811 323.969330,496.866882
	C323.969330,499.066559 323.967682,500.870300 323.969635,502.674011
	C323.983398,515.496948 323.882996,528.321472 324.051392,541.142395
	C324.169067,550.102112 328.371857,555.733093 336.483673,558.335632
	C344.615387,560.944519 352.576874,559.547791 360.374451,556.876343
	C361.390472,556.528259 362.596619,554.822998 362.589844,553.753540
	C362.567963,550.290466 362.022034,546.830750 361.670532,543.294922
	C358.877197,543.980408 356.189789,544.769653 353.451111,545.287476
	C345.446259,546.800903 342.027222,544.054443 342.012970,536.087769
	C341.990051,523.265198 342.044586,510.442535 342.593323,496.788269
z"
      />
      <path
        fill="#ffffff"
        opacity="1.000000"
        stroke="none"
        d="
M103.531342,1.000001
	C103.263016,1.663980 102.594551,2.805558 101.779091,2.922543
	C77.248703,6.441650 56.209244,16.824991 38.331245,34.063171
	C22.123236,49.691135 11.166583,68.239708 5.576090,89.961998
	C4.322172,94.834190 3.868368,99.909622 2.956399,104.875000
	C2.793999,105.759224 2.189365,106.562233 1.394466,107.201370
	C1.000000,71.740768 1.000000,36.481544 1.000000,1.000000
	C35.020573,1.000000 69.041626,1.000000 103.531342,1.000001
z"
      />
      <path
        fill="#ffffff"
        opacity="1.000000"
        stroke="none"
        d="
M693.000000,102.531342
	C692.336060,102.264290 691.203430,101.601219 691.076477,100.782288
	C687.556763,78.075714 677.600159,58.536915 662.759766,41.133461
	C652.261292,28.821779 639.630981,19.545683 625.167603,12.682609
	C614.396667,7.571691 603.118896,3.944534 591.120911,2.947190
	C590.253845,2.875117 589.437805,2.189495 588.799072,1.394570
	C623.592896,1.000000 658.185791,1.000000 693.000000,1.000000
	C693.000000,34.687237 693.000000,68.374962 693.000000,102.531342
z"
      />
      <path
        fill="#ffffff"
        opacity="1.000000"
        stroke="none"
        d="
M1.000003,544.468628
	C1.663970,544.751282 2.828043,545.446655 2.919117,546.261902
	C5.529358,569.627380 14.401156,590.134094 29.562382,608.229187
	C43.906742,625.349365 61.892307,636.607361 82.620918,644.041687
	C83.341217,644.300049 83.934616,644.912231 84.293594,645.679688
	C56.398907,646.000000 28.797817,646.000000 1.000000,646.000000
	C1.000000,612.312683 1.000000,578.625000 1.000003,544.468628
z"
      />
      <path
        fill="#ffffff"
        opacity="1.000000"
        stroke="none"
        d="
M610.468628,646.000000
	C610.665710,645.317200 611.207947,644.294739 612.015198,644.001404
	C630.580261,637.256104 647.088440,627.419006 660.713806,612.861450
	C675.692505,596.857971 685.400513,578.222046 690.024109,556.852295
	C690.627380,554.063965 691.489319,551.331604 692.615723,548.786682
	C693.000000,581.254578 693.000000,613.509094 693.000000,646.000000
	C665.646240,646.000000 638.291748,646.000000 610.468628,646.000000
z"
      />
      <path
        fill="#FF3836"
        opacity="1.000000"
        stroke="none"
        d="
M575.531372,0.999999
	C574.440552,1.339787 572.881165,1.976652 571.321594,1.977154
	C421.047852,2.025608 270.774109,2.026698 120.500389,2.012381
	C119.187386,2.012255 117.874397,1.763567 116.280701,1.315464
	C269.020905,1.000000 422.041779,1.000000 575.531372,0.999999
z"
      />
      <path
        fill="#FF3B3D"
        opacity="1.000000"
        stroke="none"
        d="
M693.000000,512.531372
	C692.688660,511.428741 692.105896,509.857666 692.104675,508.286163
	C692.012817,393.855865 691.951599,279.425537 691.939209,164.995193
	C691.937744,151.855606 692.230591,138.715988 692.693481,125.288193
	C693.000000,254.020889 693.000000,383.041779 693.000000,512.531372
z"
      />
      <path
        fill="#FAF9F9"
        opacity="1.000000"
        stroke="none"
        d="
M168.196854,340.521301
	C169.913910,341.148804 171.669281,341.589661 173.424438,341.588867
	C213.909775,341.570465 254.395111,341.503601 294.880432,341.447205
	C298.703003,341.441895 302.525604,341.446472 306.755676,341.446472
	C306.755676,359.722076 306.755676,377.582245 306.755676,395.734497
	C230.401764,395.734497 154.006104,395.734497 77.031326,395.734497
	C77.031326,383.235626 76.957993,370.801270 77.128807,358.370270
	C77.149010,356.899658 78.363426,355.352051 79.264748,354.000519
	C106.262932,313.516052 133.280334,273.044464 160.318741,232.586899
	C180.893219,201.801376 201.501587,171.038498 222.087570,140.260666
	C222.694839,139.352737 223.220093,138.389938 224.131424,136.874207
	C173.063309,136.874207 122.670357,136.874207 72.002266,136.874207
	C72.002266,118.222649 72.002266,99.958664 72.002266,81.387405
	C150.147461,81.387405 228.220154,81.387405 306.797791,81.387405
	C306.894836,82.668236 307.093414,84.084976 307.095459,85.502007
	C307.116211,99.831772 307.184937,114.162537 307.016113,128.490372
	C306.990784,130.641907 306.282410,133.092102 305.097290,134.878159
	C279.101959,174.055542 253.002014,213.163574 226.905945,252.274124
	C207.360733,281.566864 187.792862,310.844513 168.196854,340.521301
z"
      />
      <path
        fill="#FAF7F7"
        opacity="1.000000"
        stroke="none"
        d="
M635.911743,232.000061
	C635.922668,280.652496 635.933838,328.804962 635.942261,376.957397
	C635.944641,390.795013 630.854187,395.998871 617.045837,396.003967
	C538.069275,396.033234 459.092743,396.036316 380.116180,396.016388
	C368.150879,396.013367 362.730957,390.531555 362.737122,378.662415
	C362.784698,287.024261 362.864594,195.386108 362.822937,103.748009
	C362.820221,97.826599 364.765533,93.244469 368.970245,89.146637
	C380.659851,77.754028 392.166718,66.173546 403.719360,54.640862
	C408.192352,50.175591 413.589294,48.025909 419.857208,48.025101
	C472.175201,48.018356 524.493164,48.013645 576.811157,48.044365
	C582.856079,48.047916 588.238647,49.994633 592.584961,54.315144
	C605.345642,67.000069 618.080139,79.711426 630.807983,92.429283
	C634.847229,96.465309 635.923767,101.513260 635.918579,107.036232
	C635.879639,148.524139 635.905457,190.012115 635.911743,232.000061
M491.500000,91.996758
	C512.492859,91.996910 533.485718,91.978065 554.478577,92.011391
	C559.352600,92.019127 562.457825,95.073250 561.758789,99.287514
	C561.030579,103.677849 558.073486,105.005768 553.811218,104.994797
	C521.485901,104.911530 489.151855,105.377426 456.839508,104.728165
	C446.550171,104.521416 438.389099,106.473984 432.386932,115.051094
	C423.265533,128.085587 410.755676,132.524902 395.205200,130.448975
	C389.066467,129.629486 382.726837,130.314606 376.475311,130.314606
	C376.475311,139.120346 376.475311,146.867004 376.475311,154.987442
	C388.086060,154.987442 399.385773,155.053207 410.682343,154.895523
	C411.945435,154.877884 413.418701,153.825119 414.408081,152.857361
	C421.789673,145.636948 428.886169,138.111572 436.501434,131.151611
	C438.828613,129.024628 442.483856,127.245865 445.553375,127.209625
	C471.710144,126.900795 497.872070,127.020309 524.032471,127.037193
	C529.621277,127.040802 532.163757,129.100677 532.191956,133.485260
	C532.220337,137.902267 529.739014,139.933548 524.109985,139.940659
	C504.281464,139.965698 484.452850,139.949097 464.624298,139.962967
	C458.127899,139.967514 450.933899,138.282211 445.332062,140.535217
	C439.770508,142.772034 435.811584,148.993088 431.148926,153.465881
	C430.668060,153.927155 430.173187,154.373978 429.697998,154.840927
	C413.629700,170.629639 420.408752,167.556946 397.165924,167.930054
	C390.246582,168.041138 383.323975,167.947189 376.165192,167.947189
	C376.165192,170.471039 376.165680,172.282684 376.165100,174.094345
	C376.143951,241.244278 376.128418,308.394226 376.093414,375.544159
	C376.089600,382.842133 376.212524,383.011841 383.715149,383.011871
	C460.696716,383.011902 537.678284,383.012054 614.659851,383.013947
	C622.203735,383.014130 622.210693,383.019623 622.210632,375.579559
	C622.210144,291.267090 622.207458,206.954620 622.205261,122.642159
	C622.205200,120.195808 622.205261,117.749458 622.205261,114.929184
	C609.830750,114.929184 598.040283,114.979668 586.250610,114.912231
	C577.744629,114.863586 573.955627,111.359047 573.658997,102.914391
	C573.407654,95.758507 573.605225,88.586838 573.604736,81.422157
	C573.604309,75.143288 573.604675,68.864418 573.604675,62.207542
	C564.670959,62.207542 556.533325,62.203377 548.395691,62.208233
	C505.740204,62.233685 463.084564,62.225025 420.429626,62.391205
	C418.195221,62.399906 415.390900,63.301403 413.826996,64.802895
	C401.931793,76.223099 390.264465,87.881172 378.578644,99.517860
	C377.565063,100.527138 376.302124,101.878914 376.228943,103.134239
	C375.951874,107.885208 376.117523,112.661995 376.117523,117.787041
	C388.128845,117.787041 399.424530,117.870895 410.715576,117.680717
	C412.124481,117.656990 413.748077,116.428314 414.865295,115.340164
	C421.428467,108.947906 427.969238,102.525970 434.308167,95.913330
	C437.057800,93.044991 440.043060,91.886223 444.011963,91.928932
	C459.506409,92.095634 475.003754,91.996597 491.500000,91.996758
M615.255005,95.264023
	C606.019348,86.077858 596.783691,76.891693 587.240845,67.399963
	C587.240845,78.927948 587.240845,89.778542 587.240845,100.611031
	C598.296631,100.611031 608.955078,100.611031 620.276794,100.611031
	C618.434937,98.637299 617.096191,97.202644 615.255005,95.264023
z"
      />
      <path
        fill="#FAF7F7"
        opacity="1.000000"
        stroke="none"
        d="
M440.345215,555.471008
	C439.303314,556.617065 438.302856,557.845520 437.244141,557.897949
	C432.764435,558.119812 428.267334,557.991943 422.999847,557.991943
	C422.999847,556.275452 423.000000,554.698730 422.999817,553.122009
	C422.998169,538.968262 423.041718,524.814392 422.980408,510.660889
	C422.931946,499.473969 415.602783,494.355194 405.048157,498.041595
	C404.113190,498.368164 403.198608,498.766785 402.304779,499.195007
	C396.139130,502.148712 392.337646,505.708740 392.906372,513.910217
	C393.905121,528.313721 393.185364,542.836365 393.185364,557.693665
	C387.134949,557.693665 381.411896,557.693665 375.359497,557.693665
	C375.359497,522.441772 375.359497,487.223236 375.359497,451.649475
	C381.022461,451.649475 386.749451,451.649475 392.860046,451.649475
	C392.860046,465.269196 392.860046,478.841156 392.860046,491.763336
	C398.961639,488.719421 404.709564,484.508575 411.108154,482.922699
	C427.469513,478.867584 440.728027,489.719635 440.803955,506.566040
	C440.876709,522.713806 440.525024,538.863464 440.345215,555.471008
z"
      />
      <path
        fill="#FAF7F7"
        opacity="1.000000"
        stroke="none"
        d="
M529.723694,472.037354
	C529.704102,467.281403 529.704102,462.969543 529.704102,458.283295
	C551.713013,458.283295 573.561951,458.283295 595.727173,458.283295
	C595.999084,465.965332 596.178406,472.935333 591.183777,479.954803
	C578.196289,498.207611 566.179504,517.151306 553.782898,535.824280
	C552.522034,537.723572 551.312500,539.656921 549.535889,542.419128
	C566.611938,542.419128 582.935669,542.419128 599.522827,542.419128
	C599.522827,547.865234 599.522827,552.608093 599.522827,557.680908
	C575.408203,557.680908 551.532837,557.680908 527.335083,557.680908
	C526.851990,551.491150 526.463074,545.843079 530.334839,540.148254
	C544.706604,519.009399 558.612000,497.553528 572.691772,476.216217
	C573.116577,475.572510 573.532715,474.923126 574.534546,473.381134
	C561.937561,473.381134 550.190125,473.439056 538.444031,473.340057
	C535.541565,473.315613 532.643433,472.781342 529.723694,472.037354
z"
      />
      <path
        fill="#FAF5F6"
        opacity="1.000000"
        stroke="none"
        d="
M111.049011,558.019897
	C108.994286,557.641113 107.331284,557.431702 105.758842,556.935364
	C87.256859,551.096008 91.340118,556.407043 91.274399,537.023621
	C98.081406,538.864319 104.774704,541.419373 111.684204,542.325195
	C118.109856,543.167603 124.814934,542.689331 131.303864,541.961853
	C135.866547,541.450317 139.153687,538.193665 139.922913,533.472168
	C140.771179,528.265503 139.711090,523.234802 134.956558,520.261719
	C130.921692,517.738586 126.397865,515.983337 122.046257,513.984497
	C116.494446,511.434204 110.666672,509.390045 105.371971,506.395508
	C95.906395,501.042114 91.769066,492.589691 92.922951,481.727966
	C94.031090,471.296936 99.095428,463.769135 109.090187,459.763245
	C123.408066,454.024628 137.411514,456.146332 151.283875,461.274414
	C152.360565,461.672424 153.595169,463.303314 153.675613,464.437775
	C153.964462,468.510559 153.788910,472.616272 153.788910,477.286987
	C142.899612,473.491180 132.772522,470.464600 121.930664,471.966492
	C114.068901,473.055603 110.022255,477.782745 110.909485,485.026886
	C111.489815,489.765198 114.854691,492.273071 118.686653,494.022827
	C125.608261,497.183441 132.729965,499.902557 139.699570,502.962189
	C148.189865,506.689453 155.557678,511.895691 157.914871,521.414551
	C161.390884,535.451538 157.017365,552.899841 135.193848,557.540588
	C127.597137,559.155945 119.403709,557.965149 111.049011,558.019897
z"
      />
      <path
        fill="#FAF6F6"
        opacity="1.000000"
        stroke="none"
        d="
M217.742813,528.788940
	C213.378296,541.545349 209.329453,553.996765 204.871475,566.299927
	C198.150131,584.849487 182.404297,592.740906 164.602753,586.360779
	C165.436249,582.434814 166.285995,578.432312 167.199234,574.130737
	C168.549805,574.130737 169.869919,573.986267 171.149277,574.153625
	C180.961929,575.437195 186.926926,570.398315 189.612350,560.706848
	C190.328186,558.123413 188.706604,554.657654 187.571106,551.832947
	C178.569885,529.441833 169.426819,507.107697 160.139557,484.294800
	C166.957184,484.294800 173.316650,484.294800 180.148346,484.294800
	C186.286163,501.211945 192.505814,518.354614 199.071091,536.449890
	C203.947586,519.866028 208.614426,504.417877 212.970108,488.882507
	C214.047012,485.041534 215.653366,483.435028 219.805725,483.893982
	C223.912689,484.347900 228.109024,483.993225 232.747070,483.993225
	C227.718597,499.014099 222.796951,513.715881 217.742813,528.788940
z"
      />
      <path
        fill="#FAF5F5"
        opacity="1.000000"
        stroke="none"
        d="
M472.419922,485.232483
	C479.597778,484.161194 486.632446,481.745728 493.223328,482.631744
	C513.239014,485.322479 519.351868,501.294647 518.509277,518.268188
	C518.371704,521.039185 517.599121,523.778625 517.101746,526.637817
	C509.051422,526.637817 501.409607,526.637878 493.767761,526.637878
	C486.297394,526.637878 478.827026,526.637817 471.404846,526.637817
	C470.599792,537.454224 478.888702,546.069641 490.510315,545.856445
	C498.509766,545.709778 506.481110,544.030212 514.688477,543.007996
	C514.994690,545.673157 515.544312,549.107788 515.689636,552.559326
	C515.732239,553.569214 514.846680,555.284363 514.011719,555.566345
	C498.229828,560.898132 482.303131,562.747559 467.417145,553.486389
	C453.321747,544.717041 450.780090,530.417786 452.395508,515.350037
	C453.794006,502.305603 459.992401,491.752258 472.419922,485.232483
M496.942871,498.563232
	C491.353241,494.022064 485.324432,493.807037 479.428467,497.525391
	C473.612183,501.193451 470.817627,506.719910 471.082825,513.825806
	C481.179260,513.825806 490.916809,513.825806 500.750732,513.825806
	C501.649811,508.326080 500.649384,503.486969 496.942871,498.563232
z"
      />
      <path
        fill="#FAF6F6"
        opacity="1.000000"
        stroke="none"
        d="
M251.650070,483.994232
	C253.129242,485.112946 254.546844,486.068176 255.082382,487.382751
	C255.868561,489.312561 256.024170,491.499237 256.586212,494.250916
	C262.240753,487.965820 268.624420,483.409424 276.787354,482.419098
	C289.371155,480.892395 304.900787,486.145752 304.981262,505.269379
	C305.054657,522.709045 304.996796,540.149292 304.996796,557.800415
	C298.741150,557.800415 293.466309,557.800415 287.587524,557.800415
	C287.587524,555.741272 287.578796,553.785400 287.588928,551.829712
	C287.658051,538.513306 287.746094,525.196960 287.798706,511.880463
	C287.850800,498.700043 280.045776,493.584930 267.800049,498.746094
	C259.288391,502.333435 258.342255,503.982727 258.406738,513.234436
	C258.509796,528.013977 258.434326,542.794800 258.434326,557.822327
	C252.235168,557.822327 246.612411,557.822327 240.543793,557.822327
	C240.543793,533.438904 240.543793,509.084045 240.543793,483.991394
	C244.025101,483.991394 247.609604,483.991394 251.650070,483.994232
z"
      />
      <path
        fill="#FAF7F7"
        opacity="1.000000"
        stroke="none"
        d="
M342.329834,497.204102
	C342.044586,510.442535 341.990051,523.265198 342.012970,536.087769
	C342.027222,544.054443 345.446259,546.800903 353.451111,545.287476
	C356.189789,544.769653 358.877197,543.980408 361.670532,543.294922
	C362.022034,546.830750 362.567963,550.290466 362.589844,553.753540
	C362.596619,554.822998 361.390472,556.528259 360.374451,556.876343
	C352.576874,559.547791 344.615387,560.944519 336.483673,558.335632
	C328.371857,555.733093 324.169067,550.102112 324.051392,541.142395
	C323.882996,528.321472 323.983398,515.496948 323.969635,502.674011
	C323.967682,500.870300 323.969330,499.066559 323.969330,496.866882
	C320.212769,496.662811 316.800598,496.477478 313.123474,496.277710
	C313.123474,492.220276 313.123474,488.456726 313.123474,484.128113
	C316.485443,484.128113 319.880280,484.128113 323.560547,484.128113
	C324.102264,477.230133 324.603546,470.847046 325.120911,464.259277
	C330.699066,464.259277 335.971771,464.259277 341.848511,464.259277
	C341.848511,470.649078 341.848511,477.034332 341.848511,483.839050
	C348.846069,483.839050 355.259033,483.839050 361.807892,483.839050
	C361.807892,488.176849 361.807892,492.072357 361.807892,496.788269
	C355.206085,496.788269 348.899689,496.788269 342.329834,497.204102
z"
      />
      <path
        fill="#FF0102"
        opacity="1.000000"
        stroke="none"
        d="
M491.000000,91.996567
	C475.003754,91.996597 459.506409,92.095634 444.011963,91.928932
	C440.043060,91.886223 437.057800,93.044991 434.308167,95.913330
	C427.969238,102.525970 421.428467,108.947906 414.865295,115.340164
	C413.748077,116.428314 412.124481,117.656990 410.715576,117.680717
	C399.424530,117.870895 388.128845,117.787041 376.117523,117.787041
	C376.117523,112.661995 375.951874,107.885208 376.228943,103.134239
	C376.302124,101.878914 377.565063,100.527138 378.578644,99.517860
	C390.264465,87.881172 401.931793,76.223099 413.826996,64.802895
	C415.390900,63.301403 418.195221,62.399906 420.429626,62.391205
	C463.084564,62.225025 505.740204,62.233685 548.395691,62.208233
	C556.533325,62.203377 564.670959,62.207542 573.604675,62.207542
	C573.604675,68.864418 573.604309,75.143288 573.604736,81.422157
	C573.605225,88.586838 573.407654,95.758507 573.658997,102.914391
	C573.955627,111.359047 577.744629,114.863586 586.250610,114.912231
	C598.040283,114.979668 609.830750,114.929184 622.205261,114.929184
	C622.205261,117.749458 622.205200,120.195808 622.205261,122.642159
	C622.207458,206.954620 622.210144,291.267090 622.210632,375.579559
	C622.210693,383.019623 622.203735,383.014130 614.659851,383.013947
	C537.678284,383.012054 460.696716,383.011902 383.715149,383.011871
	C376.212524,383.011841 376.089600,382.842133 376.093414,375.544159
	C376.128418,308.394226 376.143951,241.244278 376.165100,174.094345
	C376.165680,172.282684 376.165192,170.471039 376.165192,167.947189
	C383.323975,167.947189 390.246582,168.041138 397.165924,167.930054
	C420.408752,167.556946 413.629700,170.629639 429.697998,154.840927
	C430.173187,154.373978 430.668060,153.927155 431.148926,153.465881
	C435.811584,148.993088 439.770508,142.772034 445.332062,140.535217
	C450.933899,138.282211 458.127899,139.967514 464.624298,139.962967
	C484.452850,139.949097 504.281464,139.965698 524.109985,139.940659
	C529.739014,139.933548 532.220337,137.902267 532.191956,133.485260
	C532.163757,129.100677 529.621277,127.040802 524.032471,127.037193
	C497.872070,127.020309 471.710144,126.900795 445.553375,127.209625
	C442.483856,127.245865 438.828613,129.024628 436.501434,131.151611
	C428.886169,138.111572 421.789673,145.636948 414.408081,152.857361
	C413.418701,153.825119 411.945435,154.877884 410.682343,154.895523
	C399.385773,155.053207 388.086060,154.987442 376.475311,154.987442
	C376.475311,146.867004 376.475311,139.120346 376.475311,130.314606
	C382.726837,130.314606 389.066467,129.629486 395.205200,130.448975
	C410.755676,132.524902 423.265533,128.085587 432.386932,115.051094
	C438.389099,106.473984 446.550171,104.521416 456.839508,104.728165
	C489.151855,105.377426 521.485901,104.911530 553.811218,104.994797
	C558.073486,105.005768 561.030579,103.677849 561.758789,99.287514
	C562.457825,95.073250 559.352600,92.019127 554.478577,92.011391
	C533.485718,91.978065 512.492859,91.996910 491.000000,91.996567
M592.817444,168.065613
	C590.263794,151.736725 574.005066,138.126114 554.475586,141.249100
	C536.010254,144.201904 525.556091,159.536957 527.595581,179.625458
	C527.716125,180.812729 526.623169,182.693222 525.546204,183.346664
	C509.123016,193.310684 492.608246,203.123810 476.079407,212.993332
	C474.781097,212.040634 473.605072,211.120377 472.373047,210.282455
	C458.885162,201.109039 441.746185,201.412308 429.083344,211.033936
	C417.196960,220.065628 412.351624,237.006485 417.386292,251.930832
	C424.623016,273.382843 451.042786,282.305420 470.883087,270.144012
	C472.523346,269.138580 475.504517,268.380096 476.883484,269.184814
	C493.344604,278.791199 509.620148,288.715698 525.883057,298.519958
	C520.235352,321.923157 533.144897,338.241577 547.427979,343.826263
	C563.474548,350.100433 582.259521,344.294464 591.381775,330.075897
	C600.911438,315.222260 598.756958,295.717926 586.368286,283.908691
	C579.445496,277.309662 571.155334,273.645050 561.729980,273.375458
	C549.818237,273.034698 539.920349,278.082611 531.843567,286.763031
	C515.305542,276.918823 499.093445,267.268677 482.790283,257.564270
	C488.683502,246.246567 488.668945,235.004181 483.893097,223.616379
	C500.756317,213.570267 517.260620,203.737976 533.690308,193.950150
	C543.913879,203.102966 553.771912,206.639343 563.039185,205.649399
	C580.767944,203.755646 595.407410,188.474030 592.817444,168.065613
z"
      />
      <path
        fill="#FF0304"
        opacity="1.000000"
        stroke="none"
        d="
M615.506226,95.516006
	C617.096191,97.202644 618.434937,98.637299 620.276794,100.611031
	C608.955078,100.611031 598.296631,100.611031 587.240845,100.611031
	C587.240845,89.778542 587.240845,78.927948 587.240845,67.399963
	C596.783691,76.891693 606.019348,86.077858 615.506226,95.516006
z"
      />
      <path
        fill="#FF0203"
        opacity="1.000000"
        stroke="none"
        d="
M497.197144,498.848572
	C500.649384,503.486969 501.649811,508.326080 500.750732,513.825806
	C490.916809,513.825806 481.179260,513.825806 471.082825,513.825806
	C470.817627,506.719910 473.612183,501.193451 479.428467,497.525391
	C485.324432,493.807037 491.353241,494.022064 497.197144,498.848572
z"
      />
      <path
        fill="#FAF6F6"
        opacity="1.000000"
        stroke="none"
        d="
M592.865601,168.508972
	C595.407410,188.474030 580.767944,203.755646 563.039185,205.649399
	C553.771912,206.639343 543.913879,203.102966 533.690308,193.950150
	C517.260620,203.737976 500.756317,213.570267 483.893097,223.616379
	C488.668945,235.004181 488.683502,246.246567 482.790283,257.564270
	C499.093445,267.268677 515.305542,276.918823 531.843567,286.763031
	C539.920349,278.082611 549.818237,273.034698 561.729980,273.375458
	C571.155334,273.645050 579.445496,277.309662 586.368286,283.908691
	C598.756958,295.717926 600.911438,315.222260 591.381775,330.075897
	C582.259521,344.294464 563.474548,350.100433 547.427979,343.826263
	C533.144897,338.241577 520.235352,321.923157 525.883057,298.519958
	C509.620148,288.715698 493.344604,278.791199 476.883484,269.184814
	C475.504517,268.380096 472.523346,269.138580 470.883087,270.144012
	C451.042786,282.305420 424.623016,273.382843 417.386292,251.930832
	C412.351624,237.006485 417.196960,220.065628 429.083344,211.033936
	C441.746185,201.412308 458.885162,201.109039 472.373047,210.282455
	C473.605072,211.120377 474.781097,212.040634 476.079407,212.993332
	C492.608246,203.123810 509.123016,193.310684 525.546204,183.346664
	C526.623169,182.693222 527.716125,180.812729 527.595581,179.625458
	C525.556091,159.536957 536.010254,144.201904 554.475586,141.249100
	C574.005066,138.126114 590.263794,151.736725 592.865601,168.508972
M555.208923,287.067657
	C553.374756,287.822632 551.451538,288.414581 549.721130,289.359558
	C539.941223,294.700317 535.423218,305.034058 538.031677,315.867767
	C540.278564,325.199463 549.370789,332.743866 558.772888,333.078125
	C571.023987,333.513611 580.312988,327.456360 583.339844,316.324097
	C588.102051,298.808960 573.778748,283.570129 555.208923,287.067657
M472.940765,248.126068
	C473.078979,247.647263 473.215027,247.167801 473.355804,246.689743
	C476.316498,236.637375 473.284515,226.892227 465.338135,220.921570
	C457.760620,215.228119 445.889496,214.938492 438.232178,220.260208
	C430.120148,225.897949 426.460754,235.935883 428.946228,245.732193
	C431.253387,254.825653 439.537628,261.755096 449.418304,262.856171
	C458.554413,263.874298 467.788269,258.315033 472.940765,248.126068
M546.068237,187.455551
	C547.561951,188.495682 548.958618,189.726807 550.565796,190.543625
	C558.468201,194.559784 566.018860,193.465897 572.955444,188.330627
	C578.833130,183.979309 581.446960,175.226654 579.384521,168.198380
	C577.007812,160.099060 570.676758,154.643982 562.780457,153.891708
	C553.205566,152.979523 546.044983,156.317810 542.338074,163.932800
	C538.311096,172.205444 539.261230,179.994308 546.068237,187.455551
z"
      />
      <path
        fill="#FF0203"
        opacity="1.000000"
        stroke="none"
        d="
M555.642517,287.020172
	C573.778748,283.570129 588.102051,298.808960 583.339844,316.324097
	C580.312988,327.456360 571.023987,333.513611 558.772888,333.078125
	C549.370789,332.743866 540.278564,325.199463 538.031677,315.867767
	C535.423218,305.034058 539.941223,294.700317 549.721130,289.359558
	C551.451538,288.414581 553.374756,287.822632 555.642517,287.020172
z"
      />
      <path
        fill="#FF0203"
        opacity="1.000000"
        stroke="none"
        d="
M472.805939,248.491409
	C467.788269,258.315033 458.554413,263.874298 449.418304,262.856171
	C439.537628,261.755096 431.253387,254.825653 428.946228,245.732193
	C426.460754,235.935883 430.120148,225.897949 438.232178,220.260208
	C445.889496,214.938492 457.760620,215.228119 465.338135,220.921570
	C473.284515,226.892227 476.316498,236.637375 473.355804,246.689743
	C473.215027,247.167801 473.078979,247.647263 472.805939,248.491409
z"
      />
      <path
        fill="#FF0203"
        opacity="1.000000"
        stroke="none"
        d="
M545.813232,187.191620
	C539.261230,179.994308 538.311096,172.205444 542.338074,163.932800
	C546.044983,156.317810 553.205566,152.979523 562.780457,153.891708
	C570.676758,154.643982 577.007812,160.099060 579.384521,168.198380
	C581.446960,175.226654 578.833130,183.979309 572.955444,188.330627
	C566.018860,193.465897 558.468201,194.559784 550.565796,190.543625
	C548.958618,189.726807 547.561951,188.495682 545.813232,187.191620
z"
      />
    </svg>
  );
}

export default forwardRef(SVGSyntheZ);
